<template>
  <div class="clip-layer" :data-clip="'clip--' + selectData.clipId">
    <div class="clip-layer__bg">
      <div class="clip-layer__bg-view">
        <video id="clipVideo" :src="selectData.video" muted playsinline />
      </div>
    </div>
    <div class="clip-layer__contents">
      <div class="clip-layer__txt">
        <div class="clip-layer__txt-bg"></div>
        <div class="clip-layer__txt-bl">
          <span class="bl--1"></span><span class="bl--2"></span
          ><span class="bl--3"></span>
          <hr class="bl--r" />
          <hr class="bl--l" />
        </div>
        <div
          class="clip-layer__txt-tit"
          :class="'clip-layer__txt-tit--' + selectData.clipId"
          v-html="selectData.tit"
        ></div>
        <div class="clip-layer__txt-desc" v-html="selectData.desc"></div>
        <div class="clip-layer__story"></div>
      </div>
    </div>
    <button class="clip-layer__close" @click="close"></button>
    <!--    <button class="clip-layer__view" @click="viewVideo"></button>-->
    <button
      v-if="selectData.youtube != ''"
      class="clip-layer__youtube"
      @click="viewYoutube"
    ></button>
    <div v-if="selectData.coming" class="clip-layer__coming"></div>
  </div>
</template>
<script>
import gsap from "gsap";
import promokit from "@/utils/promokit";
import { mapState } from "vuex";
import MotionPathPlugin from "gsap/MotionPathPlugin";
gsap.registerPlugin(MotionPathPlugin);

export default {
  props: ["selectData"],
  components: {},
  data() {
    return {
      name: "clip-layer",
      enterMotion: null,
      video: null,
    };
  },
  computed: {
    ...mapState(["lang"]),
  },
  methods: {
    close() {
      this.$emit("hideLayer");
    },
    setMotion() {
      this.enterMotion = new gsap.timeline({ paused: true });
      this.enterMotion.from(
        this.$el.querySelector(".clip-layer__bg"),
        0.5,
        { opacity: 0, onComplete: () => {} },
        "+=0.2"
      );
      //  .from(this.$el.querySelector('.clip-layer__close'), 0.5, {opacity:0})
    },
    createStroy() {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      if (this.selectData.story !== undefined) {
        const stories = this.selectData.story.split("|");
        const storyCon = this.$el.querySelector(".clip-layer__story");
        const storyMotion = new gsap.timeline({
          delay: 2,
          onComplete: () => {
            storyMotion.restart();
          },
        });

        storyMotion.timeScale(0.75);
        storyMotion.addLabel("txt");
        for (let i = 0; i < stories.length; i++) {
          storyCon.appendChild(
            parse(`
            <div class='clip-layer__story-txt story-txt--${i}'>${stories[i]}</div>
            `)
          );

          const subMotion = new gsap.timeline();
          subMotion.fromTo(
            this.$el.querySelector(`.story-txt--${i}`),
            2.5,
            { y: 400, alpha: 0 },
            { scale: 1, y: 300, alpha: 0.6, ease: "none" }
          );
          subMotion.to(this.$el.querySelector(`.story-txt--${i}`), 5, {
            y: 100,
            ease: "none",
          });
          subMotion.to(this.$el.querySelector(`.story-txt--${i}`), 2.5, {
            y: 0,
            alpha: 0,
            ease: "none",
          });
          storyMotion.add(subMotion, `txt+=${i * 1}`);
        }

        // const motionPath= [{scale:0.8, y:400, alpha:0}, {scale:1, y:200, alpha:1}, {scale:0.8, y:0, alpha:0}]
        // const storyMotion = new gsap.timeline({});
        // storyMotion.to(this.$el.querySelectorAll('.clip-layer__story-txt'), {
        //   motionPath:{
        //     path:motionPath,
        //
        //   },
        //   duration:15,
        //   stagger: {
        //     each: 1,
        //     repeat: -1
        //   },
        //
        //   ease:"Linear.easeNone",
        // })
      }
    },
    viewVideo() {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      const layerEle = `<div id="videoLayer">
            <div id="videoPlayer"></div>
          </div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const player = promokit.video({
        el: "#videoPlayer",
        url: this.selectData.video,
        controls: true,
        mute: false,
      });
      const layer = promokit.layer({
        el: "#videoLayer",
        render: true,
        autoplayVideo: player,
      });
      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
    viewYoutube() {
      const parseRange = document.createRange();
      const parse = Range.prototype.createContextualFragment.bind(parseRange);
      const layerEle = `<div id="videoLayer">
            <div id="videoPlayer"></div>
          </div>`;
      document.querySelector("body").appendChild(parse(layerEle));

      const player = promokit.youtube({
        el: "#videoPlayer",
        youtubeid: this.selectData.youtube[this.lang],
        controls: true,
        mute: false,
      });
      const layer = promokit.layer({
        el: "#videoLayer",
        render: true,
        autoplayVideo: player,
      });
      layer.open();
      layer.on("closeend", () => {
        document.querySelector(".promokit-layer").remove();
      });
    },
  },
  mounted() {
    this.video = this.$el.querySelector("#clipVideo");
    this.video.addEventListener("ended", (event) => {
      this.video.currentTime = 1;
      this.video.play();
    });
    this.setMotion();
    this.createStroy();
    this.enterMotion.play();

    this.video.play();
    //this.enterMotion.play();
    const titMotion = new gsap.timeline();
    titMotion
      .addLabel("title", "+=1")
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt .bl--1`),
        0.4,
        { autoAlpha: 0, rotation: 190 },
        { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
        "title"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt .bl--2`),
        0.4,
        { autoAlpha: 0, rotation: -190 },
        { autoAlpha: 1, rotation: 0, ease: "expo.easeInOut" },
        "title"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt .bl--3`),
        0.4,
        { autoAlpha: 0, scale: 3 },
        { autoAlpha: 1, scale: 1, ease: "Back.easeOut" },
        "title"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt .bl--r`),
        0.4,
        { autoAlpha: 0, x: -30, y: -5 },
        { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
        "title+=0.2"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt .bl--l`),
        0.4,
        { autoAlpha: 0, x: 30, y: -5 },
        { autoAlpha: 1, x: 0, y: 0, ease: "expo.easeInOut" },
        "title+=0.2"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt-bg`),
        0.4,
        { autoAlpha: 0, y: -10 },
        { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
        "title+=0.2"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt-tit`),
        0.4,
        { autoAlpha: 0, y: 30 },
        { autoAlpha: 1, y: 0, ease: "expo.easeOut" },
        "title+=0.4"
      )
      .fromTo(
        this.$el.querySelector(`.${this.name}__txt-desc`),
        0.4,
        { autoAlpha: 0, y: -30 },
        { autoAlpha: 0.4, y: 0, ease: "expo.easeOut" },
        "title+=0.6"
      );
  },
};
</script>
<style lang="scss">
.clip-layer {
  // opacity:0.5;
  // @include bg($bg: '../assets/img/clip_layer_guide.jpg');
  @include position(
    $position: absolute,
    $width: 100%,
    $height: 100%,
    $left: 0,
    $top: 0
  );
  overflow: hidden;
  z-index: 99999;
  &__bg {
    @include position($width: 100%, $height: 100%);
    overflow: hidden;
    // visibility: hidden;
    &-view {
      @include position(
        $position: absolute,
        $top: 0,
        $left: 0,
        $width: 100%,
        $height: 100%
      );
      overflow: hidden;
      z-clip: -1;
      video {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      &:after {
        @include position(
          $position: absolute,
          $width: 100%,
          $height: 100%,
          $top: 0,
          $left: 0
        );
        @include bg($bg: "../assets/img/clip_cover.png", $cover: cover);
        content: "";
      }
    }
  }
  &__contents {
    @include position($position: absolute, $top: 50%, $left: 50%);
    width: 100%;
    height: 100%;
    //  background: #f0f;
  }

  &__txt {
    @include position(
      $position: absolute,
      $width: 100%,
      $height: 563px,
      $top: 24px,
      $left: 50%
    );
    &-bg {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 100%,
        $top: 0,
        $left: 50%
      );
      @include bg($bg: "../assets/img/tit_bg.png", $position: 50% 0);
      transform-origin: 50% 180px;
      transform: scale(0.8);
    }
    margin-top: -70px;
    &-bl {
      @include position(
        $position: absolute,
        $width: 100%,
        $height: 34px,
        $top: 157px,
        $left: 50%
      );
      > span {
        display: block;
        @include position(
          $position: absolute,
          $width: 34px,
          $height: 34px,
          $top: 0,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_b.png");
        &:nth-child(1) {
          background-position-x: 0;
        }
        &:nth-child(2) {
          background-position-x: -34px;
        }
        &:nth-child(3) {
          background-position-x: -68px;
        }
      }
      > hr {
        border: none;
        @include position(
          $position: absolute,
          $width: 96px,
          $height: 14px,
          $top: 2px,
          $left: 50%
        );
        @include bg($bg: "../assets/img/tit_icon_l.png");
        margin-left: 17px;
        &:last-child {
          @include bg($bg: "../assets/img/tit_icon_r.png");
          margin-left: -113px;
        }
      }
    }
    &-tit {
      @include position(
        $position: absolute,
        $width: 800px,
        $height: 90px,
        $top: 215px,
        $left: 50%
      );
      @include hide-text;
      .ko & {
        &--1 {
          @include bg($bg: "../assets/img/ko/clip_1_tit.png", $cover: cover);
        }
        &--2 {
          @include bg($bg: "../assets/img/ko/clip_2_tit.png", $cover: cover);
        }
        &--3 {
          @include bg($bg: "../assets/img/ko/clip_3_tit.png", $cover: cover);
        }
        &--4 {
          @include bg($bg: "../assets/img/ko/clip_4_tit.png", $cover: cover);
        }
        &--5 {
          @include bg($bg: "../assets/img/ko/clip_5_tit.png", $cover: cover);
        }
      }
      .en & {
        &--1 {
          @include bg($bg: "../assets/img/en/clip_1_tit_en.png", $cover: cover);
        }
        &--2 {
          @include bg($bg: "../assets/img/en/clip_2_tit_en.png", $cover: cover);
        }
        &--3 {
          @include bg($bg: "../assets/img/en/clip_3_tit_en.png", $cover: cover);
        }
        &--4 {
          width: 900px;
          margin-left: -450px;
          @include bg($bg: "../assets/img/en/clip_4_tit_en.png", $cover: cover);
        }
        &--5 {
          width: 1100px;
          margin-left: -550px;
          @include bg($bg: "../assets/img/en/clip_5_tit_en.png", $cover: cover);
        }
      }
      .ja & {
        &--1 {
          @include bg($bg: "../assets/img/ja/clip_1_tit_ja.png", $cover: cover);
        }
        &--2 {
          @include bg($bg: "../assets/img/ja/clip_2_tit_ja.png", $cover: cover);
        }
        &--3 {
          @include bg($bg: "../assets/img/ja/clip_3_tit_ja.png", $cover: cover);
        }
        &--4 {
          @include bg($bg: "../assets/img/ja/clip_4_tit_ja.png", $cover: cover);
        }
        &--5 {
          @include bg($bg: "../assets/img/ja/clip_5_tit_ja.png", $cover: cover);
        }
      }
      .zh & {
        &--1 {
          @include bg($bg: "../assets/img/zh/clip_1_tit_zh.png", $cover: cover);
        }
        &--2 {
          @include bg($bg: "../assets/img/zh/clip_2_tit_zh.png", $cover: cover);
        }
        &--3 {
          @include bg($bg: "../assets/img/zh/clip_3_tit_zh.png", $cover: cover);
        }
        &--4 {
          @include bg($bg: "../assets/img/zh/clip_4_tit_zh.png", $cover: cover);
        }
        &--5 {
          @include bg($bg: "../assets/img/zh/clip_5_tit_zh.png", $cover: cover);
        }
      }
    }
    &-desc {
      @include position(
        $position: absolute,
        $width: 100%,
        $top: 317px,
        $left: 50%
      );
      font-size: 19px;
      text-align: center;
      letter-spacing: -0.9px;
      line-height: 1.8em;
      opacity: 0.4;
      .zh &,
      .en & {
        letter-spacing: 0px;
      }
    }
  }
  &__close {
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 45px,
      $left: 45px,
      $width: 50px,
      $height: 34px
    );
    overflow: visible;
    z-index: 2;
    &:before {
      opacity: 0;
      @include position(
        $position: absolute,
        $top: -34px,
        $left: -28px,
        $width: 96px,
        $height: 96px
      );
      @include bg($bg: "../assets/img/icon_ef.png", $cover: cover);
      content: "";
      pointer-events: none;
      transition: 0.3s;
      z-clip: -1;
    }
    &:after {
      @include position(
        $position: absolute,
        $top: 0px,
        $right: 0px,
        $width: 100%,
        $height: 100%
      );
      @include bg($bg: "../assets/img/icon_back.png", $cover: cover);
      content: "";
    }
    &:hover {
      &:before {
        opacity: 1;
        transition: 0.3s;
      }
    }
  }
  &__view {
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 45px,
      $right: 45px,
      $width: 39px,
      $height: 41px
    );
    overflow: visible;
    &:before {
      opacity: 0;
      @include position(
        $position: absolute,
        $top: -34px,
        $left: -28px,
        $width: 96px,
        $height: 96px
      );
      @include bg($bg: "../assets/img/icon_ef.png", $cover: cover);
      content: "";
      pointer-events: none;
      transition: 0.3s;
    }
    &:after {
      @include position(
        $position: absolute,
        $top: 0px,
        $right: 0px,
        $width: 100%,
        $height: 100%
      );
      @include bg($bg: "../assets/img/icon_view.png", $cover: cover);
      content: "";
    }
    &:hover {
      &:before {
        opacity: 1;
        transition: 0.3s;
      }
    }
  }
  &__youtube {
    // display: none;
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 50%,
      $left: 50%,
      $width: 298px,
      $height: 188px
    );
    @include bg($bg: "../assets/img/btn_youtube_ko.png", $cover: cover);
    margin-top: 300px;
    .en & {
      @include bg($bg: "../assets/img/btn_youtube_en.png", $cover: cover);
    }
    .ja & {
      @include bg($bg: "../assets/img/btn_youtube_ja.png", $cover: cover);
    }
    .zh & {
      @include bg($bg: "../assets/img/btn_youtube_zh.png", $cover: cover);
    }
  }

  &__coming {
    @include hide-text();
    @include position(
      $position: absolute,
      $top: 50%,
      $left: 50%,
      $width: 344px,
      $height: 106px
    );
    @include bg($bg: "../assets/img/btn_coming_ko.png", $cover: cover);
    margin-top: 300px;
    .en &,
    .ja &,
    .zh & {
      @include bg($bg: "../assets/img/btn_coming_en.png", $cover: cover);
    }
  }
  &__story {
    @include position(
      $position: absolute,
      $top: 400px,
      $left: 50%,
      $width: 800px,
      $height: 440px
    );
    text-align: center;
    &-txt {
      @include position(
        $position: absolute,
        $top: 0px,
        $left: 50%,
        $width: 800px,
        $height: 50px
      );
      font-family: "LineageWIdentity";
      line-height: 50px;
      font-size: 26px;
      text-shadow: 2px 3px rgba(0, 0, 0, 0.7);
    }
  }
}
</style>

